


export const ReviewDetail=(payload)=>{
    return{
        type:"REVIEW_DETAILS",
        payload
    }
}